module.exports = __webpack_public_path__ + "img/folder.b3a53ea3.svg";